module.exports = __webpack_public_path__ + "img/access_6_en.5929c521.jpg";